/**
 * O cadastro de pessoas em português (F311). Saiu de
 * `apps/web/src/lib/party-labels.ts` quando o celular passou a editar o
 * cadastro com as mesmas palavras; o site reexporta.
 */
export const PARTY_ROLE_LABELS = {
    customer: 'Cliente',
    supplier: 'Fornecedor',
    carrier: 'Transportadora',
    // "Entregador", e não "Motoboy": a palavra tem de servir para quem entrega a
    // pé, de bicicleta ou de carro, e é a que a tela de acerto já usava no rótulo
    // do campo desde a F034 — só não existia no cadastro (F098).
    courier: 'Entregador',
};
/**
 * Inscrição Estadual status.
 *
 * The three the fiscal indicator for an NF-e recipient distinguishes:
 * contribuinte, contribuinte isento, não contribuinte.
 */
export const IE_STATUS_LABELS = {
    taxpayer: 'Contribuinte',
    exempt: 'Isento',
    non_taxpayer: 'Não contribuinte',
};
export const ADDRESS_KIND_LABELS = {
    billing: 'Cobrança',
    delivery: 'Entrega',
    other: 'Outro',
};
export const CONTACT_KIND_LABELS = {
    phone: 'Telefone',
    mobile: 'Celular',
    email: 'E-mail',
    whatsapp: 'WhatsApp',
};
/** As cores de um marcador, pelo nome que a pessoa reconhece (F088). */
export const TAG_TONE_LABELS = {
    neutral: 'Cinza',
    info: 'Azul',
    success: 'Verde',
    warning: 'Âmbar',
    danger: 'Vermelho',
};
//# sourceMappingURL=party.js.map